<template>
  <div>
    <div style="font-size: 14px; color: #606266;">
      <span>Status：{{ formData.v_templateStatus }}</span>
      <el-divider direction="vertical"></el-divider>
      <span
        >Create：{{ formData.createByName }} at {{ formData.createTime }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span
        >Modify：{{ formData.modifyByName }} at {{ formData.modifyTime }}</span
      >
    </div>
    <div class="d2-mt">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
        size="medium"
      >
        <el-row :gutter="20" v-if="!isAdd">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_templateStatus') || '模版状态'"
              prop="templateStatus"
            >
              <el-radio-group v-model="formData.templateStatus">
                <el-radio label="Y" name="type">{{
                  this.$l('INDEX.form_label_valid') || '有效'
                }}</el-radio>
                <el-radio label="N" name="type">{{
                  this.$l('INDEX.form_label_invalid') || '无效'
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_templateId') || '消息模版id'"
              prop="templateId"
            >
              <el-input
                v-model="formData.templateId"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_templateName') || '模版名称'"
              prop="templateName"
            >
              <el-input
                v-model="formData.templateName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_templateTitle') || '消息标题'"
              prop="templateTitle"
            >
              <el-input
                v-model="formData.templateTitle"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_channelId') || '发送渠道'"
              prop="channelId"
            >
              <dict-select
                v-model="formData.channelId"
                url="/sys/common/dict/system"
                :body="{ dictType: 'ChannelId' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_templateDesc') || '模版描述'"
              prop="templateDesc"
            >
              <el-input
                v-model="formData.templateDesc"
                type="textarea"
                maxlength="500"
                :rows="2"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_channelExtraParams') || '渠道扩展参数'"
              prop="channelExtraParams"
            >
              <el-input
                v-model="formData.channelExtraParams"
                type="textarea"
                :rows="2"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_templateContent') || '模版消息内容'"
              prop="templateContent"
            >
              <el-input
                v-model="formData.templateContent"
                type="textarea"
                :rows="18"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  props: {
    isAdd: Boolean,
    disabled: Boolean,
    templateCode: String,
  },
  data() {
    return {
      formData: {},
      channelText: '',
      rules: {
        templateId: [
          {
            required: true,
            message:
              this.$l('form_label_please_templateId') || '请输入消息模版id',
            trigger: 'blur',
          },
        ],
        templateName: [
          {
            required: true,
            message: this.$l('form_label_please_templateName') || '模版名称',
            trigger: 'blur',
          },
        ],
        channelId: [
          {
            required: true,
            message: this.$l('from_label_please_channelId') || '请输入发送渠道',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.templateCode) return
      this.$api
        .sysMessageTemplateDetailApi({
          templateCode: this.templateCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async subsribeConfirm(data) {
      if (!data || !data.length) return
      this.$refs.messageSubscribeTable.insertAt(data)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .sysMessageTemplateSaveApi({ ...this.formData })
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (this.isAdd) {
            this.closeCurPage()
          }
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    orgChange(val) {
      this.formData.depCode = ''
      this.formData.depName = ''
      this.depParams = { orgCode: val }
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style scoped>
::v-deep ::-webkit-scrollbar {
  /* 滚动条宽度和高度 */
  width: 8px;
  height: 8px;
}
::v-deep ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #d4d6d9;
}
::v-deep ::-webkit-scrollbar-track-piece {
  /*滚动条里面轨道*/
  background-color: #fff;
  border-radius: 10px;
}
</style>
